import React from "react";
import ReactDOM from "react-dom";
import { createStore, compose } from "redux";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { I18nextProvider } from "react-i18next";

import i18n from "i18n";

import routes from "consts/routes";
import rootReducers from "reducers";
import rootMiddlewares from "middlewares";

import "./style.css";

const initialState = {};

const composeEnhancers =
  process.env.NODE_ENV !== "production" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
const store = createStore(rootReducers, initialState, composeEnhancers(rootMiddlewares));

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>{renderRoutes(routes)}</BrowserRouter>
    </I18nextProvider>
  </Provider>,
  document.getElementById("wf-an-h-app")
);



// WEBPACK FOOTER //
// ./src/index.js